
import { useState, useEffect } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputText from "../../helpers/InputText";
import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputDateTime from "../../helpers/InputDateTime";
import InputKidsMulti from "../../helpers/InputKidsMulti";
import InputCombo from "../../helpers/InputCombo";

import trash from "../../trash.png";


function CardsEdit(props)
{

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
 

    const [row, setRowX] = useState({
         id: props.row.id,
         card_id: props.row.card_id,
         opis: props.row.opis,
         termin_waznosci_od: props.row.termin_waznosci_od,
         termin_waznosci_do: props.row.termin_waznosci_do,
         przypisania: props.row.przypisania,

         dziecko: '',     //wybrane id dziecka.. tylko jedno powinno byc..
         osoba: '',       //wybranoa osoba do przypisania
        
     });
     var tmpRow = row;


 
     const [person, setPerson] = useState([]);


     const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');
    
        setView({...view, ["v"]:v, ["id"]:id });

        if(v == "add_emp") 
        {
                getEmp();
                setPerson([]);          

                setRowX(  {...row, ["osoba"]: '', ["dziecko"]:'' } );
            

        }

        if(v == "add_kid") {

            setPerson([]);       

            setRowX(  {...row, ["osoba"]: '', ["dziecko"]:'' } );
        }
    }


     
     const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
        var tabCheck = filedName.split('@');
        if(tabCheck.length == 2)
        {
            var tabName = tabCheck[0];
            var tabInx  = tabCheck[1];
            var tRef = row[tabName];
            if(correct)tRef[tabInx] = val;
            if(!correct)tRef[tabInx] = "";

            tmpRow[tabName] = tRef;     
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  

            //setRowX( {...row, [tabName]:tRef } );   
            return;
        }

      
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );    
    
        //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );    


     
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }




    const onKidsSelected = (tab) => {       
       // setKids(tab);    
        
        if(tab.length > 0)
        {
              getPersonKid( tab[0].id );

              setRowX({...row, ["dziecko"]: tab[0].id   });
        }
        if(tab.length == 0) 
        {
             setPerson([]);
        }
    }





    const getCard = () => {
       
 
        props.mainView.setProgress(-2);
    
       
        var req = {
            id: row.id,
        };
    
        fetch( Config.url + '/rest_v1_access,card_one', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                          //setTab(res.result.przypisania);            

                          setRowX({...row, ["przypisania"]:res.result.przypisania   });
              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   
    
         return false;
    }
    


    const saveData = () => {


 

        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    

        props.mainView.setProgress(-2);

        var ids = new Array();

        
        ids.push({
            id: row.id,
            title: "",
        });


        var req = {
            ids: ids,     
            option: 'info'   ,
            opis: row.opis,
            termin_waznosci_od: row.termin_waznosci_od,                     
            termin_waznosci_do: row.termin_waznosci_do,                     
        }


        fetch( Config.url + '/rest_v1_access,cards_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                                               
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
 

    const assignToCard = () => {



            if( view.v == "add_kid" &&  (row.dziecko.length < 1  || row.dziecko == '_x_' )  )
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz prawidłowo osoby"  ,  "ok"  ,null); 
                return;
            }

            if( view.v == "add_kid" &&  (row.osoba.length < 1 || row.osoba == '_x_')   )
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz prawidłowo osoby"  ,  "ok"  ,null); 
                    return;
                }


            if( view.v == "add_emp" &&  (row.osoba.length < 1  || row.osoba == '_x_'  )  )
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz prawidłowo osoby"  ,  "ok"  ,null); 
                    return;
                }            
        
    
            props.mainView.setProgress(-2);
    
            
    
            var req = {
                id: row.id,     
                dziecko: row.dziecko   ,                    
                osoba: row.osoba   ,                    
            }
    
    
            fetch( Config.url + '/rest_v1_access,card_assign', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            getCard();

                            setView({...view, ["v"]:"list", ["id"]:-1 });                                                                                 
                            setPerson([]);                                       
                            setRowX(  {...row, ["osoba"]: '', ["dziecko"]:'' } );                                                                                 

                            props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                                               
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;


    }





    const getPersonKid = (id) => {
       
 
        props.mainView.setProgress(-2);
    
       
        var req = {
            id: id,
        };
    
        fetch( Config.url + '/rest_v1_access,card_kid_person', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    { 
                          setPerson(res.result);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   
    
         return false;
    }
 
    const getEmp = (id) => {
       
 
        props.mainView.setProgress(-2);
    
       
        var req = {
            id: id,
        };
    
        fetch( Config.url + '/rest_v1_access,card_emp', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    { 
                          setPerson(res.result);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   
    
         return false;
    }





    const goDelete = (e) => {

        var id = e.target.getAttribute("id");
        
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć przypisaną osobę?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteApproved(id);
                        //--------
        } );
    }

    const goDeleteApproved = (id) => {

     

        props.mainView.setProgress(-2);

        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_access,card_delete_person', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {

                        getCard();

                        setView({...view, ["v"]:"list", ["id"]:-1 });                                                                                 
                        setPerson([]);                                       
                        setRowX(  {...row, ["osoba"]: '', ["dziecko"]:'' } );

                        props.mainView.showDialog( "Sukces",  "Operacja zakończona sukcesem", "ok" , null);                                                
                     
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }






    return (
        <div className="view_content">

               <h1><PlTitle userData={props.userData} /> / {row.card_id} </h1>


               <form className="eForm bg_center">                                        

                    <div className="form_tab">


                                            <div className="form_control">
                                                <div className="fieldName">Opis własny*</div>
                                                <InputText   userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Opis: "} className=' w400 ' req='1' firstUp="1" />
                                            </div>


                                        <div className="form_split"></div>


                                        <div className="form_control">
                                            <div className="fieldName">Ważna od dnia*</div>
                                            <InputDateTime   userData={props.userData} value={row.termin_waznosci_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_waznosci_od" placeholder={"Od dnia: "} className=' w250 ' req='1' firstUp="1" />
                                        </div>

                                        <div className="form_control">
                                            <div className="fieldName">Ważna do dnia*</div>
                                            <InputDateTime   userData={props.userData} value={row.termin_waznosci_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_waznosci_do" placeholder={"Do dnia: "} className=' w250 ' req='1' firstUp="1" />
                                        </div>

                    </div>


                    

                    <div className="form_split"></div>

                    <div className="form_btn">
                            <div className="btn" onClick={saveData}>zapisz</div>
                            &nbsp;&nbsp;
                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                    </div>

               </form>

 
               <h1>Osoby przypisane do karty ({row.przypisania.length}) </h1>

               {
                    row.przypisania.length == 0  &&
                    <div>
                              {
                                view.v == "list" &&
                                <div>
                                            <div className="btn" onClick={changeView} v="add_kid" id={-1}   > Przypisz dziecko</div> 
                                            &nbsp;&nbsp;
                                           <div className="btn" onClick={changeView} v="add_emp" id={-1}   > Przypisz pracownika</div> 
                                </div>
                              }  
                                                          
                              
                              {
                                    view.v == "add_kid" && 
                                    <div>
                                            <form className="eForm bg_center">

                                                        
                                                        <div className="form_tab">               
                                                                    <InputKidsMulti   userData={props.userData}  mainView={props.mainView} onKidsSelected={onKidsSelected}  max="1"  />  
                                                        </div>

                                  
                                                        <div className="form_tab">       
                                                              <div className="fieldName">Rodzic / Opiekun</div>        
                                                              <InputCombo items={person} value={row.osoba} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"osoba"} placeholder={""} className='  ' req='0'   />     
                                                        </div>


                                                        <div className="form_btn">
                                                                <div className="btn" onClick={assignToCard}>zapisz</div>
                                                                &nbsp;&nbsp;
                                                                <div className="btn" onClick={changeView} v="list" id={-1}   > anuluj</div>
                                                        </div>

                                            </form>
                                    </div>

                                }


                                {
                                    view.v == "add_emp" && 
                                    <div>
                                           <form className="eForm bg_center">

                                                  

                                                    <div className="form_tab">       
                                                        <div className="fieldName">Pracownik</div>        
                                                        <InputCombo items={person} value={row.osoba} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"osoba"} placeholder={""} className='  ' req='0'   />     
                                                    </div>


                                                    <div className="form_btn">
                                                            <div className="btn" onClick={assignToCard}>zapisz</div>
                                                            &nbsp;&nbsp;
                                                            <div className="btn" onClick={changeView} v="list" id={-1}   > anuluj</div>
                                                    </div>

                                                    </form>
                                    </div>

                                }


                    </div>
               }


               {
                    row.przypisania.length > 0  &&
                    <div className="bg_center">

                                    <table className="table" >
                                                <thead>
                                                        <tr className="header">                                                 
                                                            <td className="gocenter">LP</td>                                                                                                                                           
                                                            <td className="gocenter">Typ/Id</td>                                                                                                                                             
                                                            <td>Imię, nazwisko</td>                                                                                                                                             
                                                            <td>Opiekun, os. upow.</td>                                                                                                                                             
                                                            <td>Numer przypisania</td>                                                                                                                                             
                                                            <td> </td>                                                                                                                                             
                                                        </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        row.przypisania.map( (row, ix) => {
                                                            return (
                                                                <tr className="row">                                                 
                                                                <td className="gocenter">{ix+1}</td>                                                                                                                                           
                                                                <td className="gocenter">{row.typ} / {row.typ_id}</td>                                                                                                                                             
                                                                <td className="gocenter">{row.imie + " " + row.nazwisko}</td>                                                                                                                                             
                                                                <td className="gocenter">
                                                                    
                                                                      { 
                                                                                                row.opiekun != null  &&
                                                                                                <span>
                                                                                                   {row.opiekun.typ}: {row.opiekun.nazwisko} {row.opiekun.imie} 
                                                                                                </span>
                                                                        }

                                                                </td>                                                                                                                                             
                                                                <td className="gocenter">{row.userID}</td>                                                                                                                                             
                                                                <td className="gocenter">  <img className="ibtn" src={trash} title="Usuń"  onClick={goDelete}  id={row.id} />  </td>                                                                                                                                             
                                                            </tr>
                                                            )
                                                        } )
                                                    }
                                                </tbody>
                                    </table>

                        </div>

                }


              


        </div>
    )
}

export default CardsEdit;